import { render } from "./MarketPlaceAppList.vue?vue&type=template&id=605d0b74&scoped=true"
import script from "./MarketPlaceAppList.vue?vue&type=script&lang=js"
export * from "./MarketPlaceAppList.vue?vue&type=script&lang=js"

import "./MarketPlaceAppList.vue?vue&type=style&index=0&id=605d0b74&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605d0b74"]])

export default __exports__